// import Index from '../views/settings/Index.vue'
import MocoSettings from '../views/settings/MocoSettings.vue'
import MocoSync from '../views/settings/MocoSync.vue'
import DatabaseSettings from '../views/settings/DatabaseSettings.vue'
import ServicesStatus from '../views/settings/ServicesStatus.vue'

export default [
    {
        path: '/settings/moco-sync',
        name: 'settings',
        component: MocoSync,
        meta: { title: 'Einstellungen' }
    },
    {
        path: '/settings/index',
        redirect: '/settings'
    },
    {
        path: '/settings/moco-sync',
        name: 'settings/moco-sync',
        component: MocoSync,
        meta: { title: 'MOCO-Synchronisierung' }
    },
    {
        path: '/settings/moco-settings',
        name: 'settings/moco-settings',
        component: MocoSettings,
        meta: { title: 'MOCO-Konfiguration' }
    },
    {
        path: '/settings/databases',
        name: 'settings/databases',
        component: DatabaseSettings,
        meta: { title: 'Datenbanken' }
    },
    {
        path: '/settings/services-status',
        name: 'settings/services-status',
        component: ServicesStatus,
        meta: { title: 'Status' }
    }

]
